import React, { useEffect, useState, useContext, useCallback} from "react";
import { AuthContext } from "../context/AuthContext";
import "../css/Orders.css";

const STATUSES = [
  "pending",
  "processing",
  "printed",
  "completed",
  "cancelled",
];

const Orders = () => {
  const {
    getAllOrders,
    updateOrderStatus,
    getOrderPdf,
    deleteOrder,
  } = useContext(AuthContext);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState(null);

    const loadOrders = useCallback(async () => {
    setLoading(true);
    const res = await getAllOrders();
    if (res?.ok) setOrders(res.orders || []);
      setLoading(false);
    }, [getAllOrders]);

  useEffect(() => {
    loadOrders();
  }, [loadOrders]);

  const handleStatusChange = async (id, status) => {
    setUpdatingId(id);
    const res = await updateOrderStatus(id, status);
    setUpdatingId(null);
    if (res?.ok) loadOrders();
  };

  const viewPdf = async (id) => {
    const res = await getOrderPdf(id);
    if (res?.ok && res.pdf_url) {
      window.open(res.pdf_url, "_blank");
    }
  };

  const downloadPdf = async (id) => {
    const res = await getOrderPdf(id);
    if (res?.ok && res.pdf_url) {
      const a = document.createElement("a");
      a.href = res.pdf_url;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const printPdf = async (id) => {
    const res = await getOrderPdf(id);
    if (res?.ok && res.pdf_url) {
      const w = window.open(res.pdf_url, "_blank");
      w.onload = () => w.print();
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this order?")) return;
    const res = await deleteOrder(id);
    if (res?.ok) loadOrders();
  };

  if (loading) {
    return <div className="orders-loading">Loading orders…</div>;
  }

  return (
    <div className="orders-container">
      <h2>Orders</h2>

      <table className="orders-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>User</th>
            <th>Pages</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {orders.map((o) => (
            <tr key={o.id}>
              <td>{o.id}</td>
              <td>{o.username}</td>
              <td>{o.total_pages}</td>
              <td>₹{o.total_price}</td>

              <td>
                <select
                  value={o.status}
                  disabled={updatingId === o.id}
                  onChange={(e) =>
                    handleStatusChange(o.id, e.target.value)
                  }
                >
                  {STATUSES.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </td>

              <td>{o.created_at}</td>

              <td className="actions">
                <button onClick={() => viewPdf(o.id)}>View</button>
                <button onClick={() => downloadPdf(o.id)}>
                  Download
                </button>
                <button onClick={() => printPdf(o.id)}>Print</button>
                <button
                  className="danger"
                  onClick={() => handleDelete(o.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Orders;
